import type { SVGProps } from 'react';

export function MetamaskIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.712 3.136c.497-.303 1.117-.081 1.37.49l.812 1.841c.104.236.133.505.08.762l-1.287 6.318c-.044.213-.031.436.035.642l1.182 3.681c.271.846-.393 1.695-1.166 1.493l-3.962-1.035a.91.91 0 0 0-.835.206l-1.114.969a1.2 1.2 0 0 0-.391.872l-.011.518c-.013.615-.457 1.107-1 1.107h-2.827c-.544 0-.989-.492-1.002-1.107l-.01-.518a1.2 1.2 0 0 0-.391-.872l-1.114-.97a.91.91 0 0 0-.835-.205l-4.018 1.05c-.762.199-1.422-.623-1.175-1.463l1.256-4.27c.06-.204.068-.424.022-.633L2.057 6.239a1.27 1.27 0 0 1 .075-.783l.808-1.83c.252-.572.873-.793 1.37-.49l5.087 3.102c.146.089.31.135.475.135h4.278a.9.9 0 0 0 .474-.135zM8.362 13.214c-.376-.142-.783.088-.908.513s.078.887.454 1.03l1.509.569c.375.141.781-.089.907-.514.125-.426-.078-.886-.454-1.028zm8.204.513c-.125-.425-.532-.655-.907-.513l-1.508.57c-.376.142-.579.602-.454 1.028.126.425.532.655.908.514l1.508-.57c.375-.142.579-.603.453-1.029M5.378 5.251c-.428-.288-.98-.175-1.291.265l-.323.454a1.26 1.26 0 0 0-.153 1.123l1.02 2.966c.218.633.876.908 1.405.589L7.73 9.624q.18-.109.309-.29l.38-.535c.38-.537.253-1.332-.27-1.684zm14.557.265c-.313-.44-.863-.553-1.292-.265l-2.771 1.864c-.523.352-.65 1.147-.269 1.684l.379.535c.084.12.19.218.31.29l1.693 1.024c.53.32 1.186.044 1.404-.59l1.02-2.965c.13-.378.073-.807-.152-1.123z" />
    </svg>
  );
}
